<template>
  <rmr-soft-badge
    :label="presentation.label"
    :color="presentation.color"
    :background="presentation.background"
    :icon-src="presentation.icon"
    :size="size"
  />
</template>

<script>
import { computed } from "@vue/composition-api";

import RmrSoftBadge from "@/components/ui/feedback/RmrSoftBadge.vue";
import { getSourcePresentation } from "../source-presentation";

export default {
  name: "SourceTypeBadge",
  components: { RmrSoftBadge },
  props: {
    // RMR "source" = collect channel (news_radar_source.name), not the medium.
    sourceName: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
    },
  },
  setup(props) {
    return {
      presentation: computed(() => getSourcePresentation(props.sourceName)),
    };
  },
};
</script>
